import Vue from 'vue';
import vuetify from '@/plugins/vuetify';
import '@/plugins/noty/noty';
import App from '@/App';
import router from '@/router';
import store from '@/store/store';
import i18n from '@/plugins/i18n';
import firebase from '@/plugins/firebase';
import VCalendar from 'v-calendar';
import { NORMALIZED_MIN_PATTERN_SLASHED } from '@/utils/date';

import moment from 'moment';

moment.locale('pt-br');

new Vue({
  router,
  store,
  i18n,
  vuetify,
  provide: {
    firebase,
  },
  render: h => h(App),
}).$mount('#app');

/**
 * Import third party libs
 */
import '@/plugins/v-tooltip/v-tooltip';
Vue.use(VCalendar, {
  componentPrefix: 'vc', // Use <vc-calendar /> instead of <v-calendar />
  locales: {
    'pt-BR': {
      masks: {
        L: NORMALIZED_MIN_PATTERN_SLASHED,
      },
    },
  },
});

import HighCharts from 'highcharts';
import more from 'highcharts/highcharts-more';
import wordcloudInit from 'highcharts/modules/wordcloud';
import exporting from 'highcharts/modules/exporting';
import exportingData from 'highcharts/modules/export-data';
import offlineExporting from 'highcharts/modules/offline-exporting';
import accessibility from 'highcharts/modules/accessibility';

HighCharts.wrap = HighCharts.wrap(HighCharts.Legend.prototype, 'handleOverflow', (p, h) => h);

exporting(HighCharts);
exportingData(HighCharts);
offlineExporting(HighCharts);
wordcloudInit(HighCharts);
accessibility(HighCharts);
more(HighCharts);

HighCharts.setOptions({
  lang: {
    months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
    shortMonths: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
    weekdays: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
    loading: ['Atualizando o gráfico...aguarde'],
    contextButtonTitle: 'Exportar gráfico',
    decimalPoint: ',',
    thousandsSep: '.',
    viewFullscreen: 'Ver em tela cheia',
    exitFullscreen: 'Sair da tela cheia',
    printChart: 'Imprimir gráfico',
    rangeSelectorFrom: 'De',
    rangeSelectorTo: 'Para',
    rangeSelectorZoom: 'Zoom',
    resetZoom: 'Limpar Zoom',
    resetZoomTitle: 'Voltar Zoom para nível 1:1',
  },
});

import SocialImage from '@/components/base/social/SocialImage';
Vue.component('SocialImage', SocialImage);

/**
 * Sentry starts on any screen, but set user metadata in Layout.vue,
 * screen when user is already logged in.
 */
import '@/plugins/sentry';
import '@/plugins/logrocket';
import '@/plugins/analytics';
